/** Represents a user interface control for a media player. */
export class PlayerUiControl {
  /** The name associated with the control. */
  name: string;

  /** The name of the HTML element represented by the control. */
  elementName: string;

  /** An object containing key-value pairs representing attributes of the control. */
  attributes: Record<string, string | (() => string)>;

  /**
   * Constructs an instance of the class with specified parameters.
   *
   * @param name - The name associated with the instance.
   * @param elementName - The name of the element represented by the instance.
   * @param attributes - An object containing key-value pairs representing attributes of the
   *   instance.
   */
  constructor(
    name: string,
    elementName: string,
    attributes: Record<string, string | (() => string)>
  ) {
    this.name = name;
    this.elementName = elementName;
    this.attributes = attributes;
  }
}
